import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ComponentsModule} from './components/components.module';
import {PagesModule} from '@page/pages.module';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {TranslateModule} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {CookieService} from 'ngx-cookie-service';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {ToastrModule} from 'ngx-toastr';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {ModelConfigurationDeactivateGuard} from '@app/guards/configuration/configuration.guard';
import {OverlayModule} from '@angular/cdk/overlay';
import {MatTabsModule} from '@angular/material/tabs';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import {authInterceptor} from '@app/interceptors/auth.interceptor';
import {rpcInterceptor} from '@app/interceptors/rpc.interceptor';
import {errorInterceptor} from '@app/interceptors/error.interceptor';
import { RecaptchaModule } from 'ng-recaptcha-2';
import {QuillModule} from 'ngx-quill';
import {provideVesta} from '@app/vesta/providers/provide-vesta';

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  exports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatTooltipModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatSelectModule,
    PagesModule,
    ComponentsModule,
    NgbModule,
    MatTabsModule,
    OverlayModule,
    RecaptchaModule,
    QuillModule.forRoot(),
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
      }),
    })
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    CookieService,
    ModelConfigurationDeactivateGuard,
    provideHttpClient(withInterceptors([
      authInterceptor,
      rpcInterceptor,
      errorInterceptor
    ])),
    provideVesta()
  ]
})
export class AppModule {}
